<template>
  <div>
    <div class="container">
      <div class="searchbox">
        <div class="item">
          <span>分销员</span>
          <el-input
            v-model="commission_user_name"
            style="width: 130px; margin-left: 6px"
            clearable
            @change="search"
          ></el-input>
        </div>
        <div class="item">
          <span>分销员手机号</span>
          <el-input
            v-model="commission_phone"
            style="width: 130px; margin-left: 6px"
            clearable
            @change="search"
          ></el-input>
        </div>
        <div class="item">
          <span>客户昵称</span>
          <el-input
            v-model="customer_user_name"
            style="width: 130px; margin-left: 6px"
            clearable
            @change="search"
          ></el-input>
        </div>
        <div class="item">
          <span>客户手机号</span>
          <el-input
            v-model="customer_phone"
            style="width: 130px; margin-left: 6px"
            clearable
            @change="search"
          ></el-input>
        </div>
        <div class="item">
          <span>订单编号</span>
          <el-input
            v-model="order_sn"
            style="width: 130px; margin-left: 6px"
            clearable
            @change="search"
          ></el-input>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981; margin-left: 6px"
            @click="search"
          >查询</el-button>
        </div>
      </div>
      <div
        class="flex_between"
        style="margin-bottom:10px"
      >
        <el-button
          type="primary"
          @click="excelexport"
          style="width:92px"
          size="medium"
          :disabled="
                module_id_array[0] ? !module_id_array.includes('964') : false
              "
        >导出</el-button>
        <span>
          <el-button
            type="primary"
            @click="settleAll"
            size="medium"
            :disabled="
                module_id_array[0] ? !module_id_array.includes('965') : false
              "
          >结算入账</el-button>
        </span>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
          >
          </el-table-column>
          <el-table-column
            label="订单号"
            prop="order_sn"
          >
          </el-table-column>
          <el-table-column
            label="成交金额(元)"
            prop="sale_price"
          ></el-table-column>
          <el-table-column
            label="分销员昵称"
            prop="commission_user_name"
          ></el-table-column>
          <el-table-column
            label="分销员手机号"
            prop="commission_phone"
          ></el-table-column>
          <el-table-column
            label="客户昵称"
            prop="customer_user_name"
          ></el-table-column>
          <el-table-column
            label="客户手机号"
            prop="customer_phone"
          ></el-table-column>
          <el-table-column
            label="佣金收益(元)"
            prop="commission_money"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="toDetail(scope.row.com_id)"
                :disabled="
                module_id_array[0] ? !module_id_array.includes('1001') : false
              "
              >业绩结算</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="padding-top: 20px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      commission_user_name: '',
      commission_phone: '',
      customer_user_name: '',
      customer_phone: '',
      order_sn: '',
      com_ids: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        commission_user_name: this.commission_user_name,
        commission_phone: this.commission_phone,
        customer_user_name: this.customer_user_name,
        customer_phone: this.customer_phone,
        order_sn: this.order_sn
      };
      this.axios
        .post('platform/Distribution/settlementList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
        });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //导出数据
    excelexport() {
      let loading = this.$loading();
      let data = {
        commission_user_name: this.commission_user_name,
        commission_phone: this.commission_phone,
        customer_user_name: this.customer_user_name,
        customer_phone: this.customer_phone,
        is_settlement: 0,
        order_sn: this.order_sn
      };
      this.axios
        .post('platform/Distribution/exportSettlementList', data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              '//' +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //多选
    handleSelectionChange(val) {
      let arr = val.map((item) => {
        return item.com_id;
      });
      this.com_ids = arr.toString();
    },
    //批量结算入账
    settleAll() {
      if (!this.com_ids) {
        this.$message.error('请先选择需要操作的数据');
        return false;
      }
      let loading = this.$loading({
        text: '操作正在执行中，请不要关闭或者退出当前页面'
      });
      this.$confirm('将该笔费用结算，并入到用户账户？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let data = {
            com_ids: this.com_ids
          };
          this.axios
            .post('platform/Distribution/batchSettlementStatus', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功');
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {
          loading.close();
        });
    },
    //结算详情
    toDetail(com_id) {
      this.$router.push({
        path: 'settlementdetail',
        query: {
          com_id
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px 0;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 205px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 20px;
    margin-bottom: 10px;
  }
}
</style>